export const LEGALSTATUS_LOADING = "LEGALSTATUS_LOADING";
export const LEGALSTATUS_RESET = "LEGALSTATUS_RESET";
export const GET_LEGALSTATUS = "GET_LEGALSTATUS";
export const GET_LEGALSTATUS_SUCCESS = "GET_LEGALSTATUS_SUCCESS";
export const GET_LEGALSTATUS_FAIL = "GET_LEGALSTATUS_FAIL";
export const DELETE_LEGALSTATUS = "DELETE_LEGALSTATUS";
export const DELETE_LEGALSTATUS_SUCCESS = "DELETE_LEGALSTATUS_SUCCESS";
export const DELETE_LEGALSTATUS_FAIL = "DELETE_LEGALSTATUS_FAIL";
export const UPDATE_LEGALSTATUS = "UPDATE_LEGALSTATUS";
export const UPDATE_LEGALSTATUS_SUCCESS = "UPDATE_LEGALSTATUS_SUCCESS";
export const UPDATE_LEGALSTATUS_FAIL = "UPDATE_LEGALSTATUS_FAIL";
export const ADD_NEW_LEGALSTATUS = "ADD_NEW_LEGALSTATUS";
export const ADD_LEGALSTATUS_SUCCESS = "ADD_LEGALSTATUS_SUCCESS";
export const ADD_LEGALSTATUS_FAIL = "ADD_LEGALSTATUS_FAIL";
